var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"imageListItemContainer"},_vm._l((_vm.listImages),function(image,index){return _c('ImageListItem',{key:index,attrs:{"img":image,"documentUuid":index},on:{"getClick":_vm.getClick}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }